import Hero from "../components/sections/Hero";
import CredibilityStrip from "../components/sections/CredibilityStrip";
import Manifesto from "../components/sections/Manifesto";
import CapabilityTerritories from "../components/sections/CapabilityTerritories";
import HowTheWork from "../components/sections/HowTheWork";
import SelectedWork from "../components/sections/SelectedWork";
import SessionGallery from "../components/sections/SessionGallery";
import FounderSection from "../components/sections/FounderSection";
import Recommendations from "../components/sections/Recommendations";
import InsightsSection from "../components/sections/InsightsSection";
import FinalCTA from "../components/sections/FinalCTA";

/**
 * Redesigned homepage — buyer journey:
 * Positioning → Credibility → Thesis → Capabilities → Method → Evidence → Session archive → Founder → Recommendations → Notes → CTA
 */
export default function HomePage() {
  return (
    <main data-testid="page-home">
      <Hero />
      <CredibilityStrip />
      <Manifesto />
      <CapabilityTerritories />
      <HowTheWork />
      <SelectedWork />
      <SessionGallery />
      <FounderSection />
      <Recommendations />
      <InsightsSection />
      <FinalCTA />
    </main>
  );
}
